import Constants from 'common/constants'
import Utils from 'common/utils';
import { Promise } from 'es6-promise';
import ListenerManager from 'manager/listenerManager';

class LocationPermissionStore {
    constructor() {
        this.__currentPermissionStatus = Constants.LOCATION_PERMISSION_STATUS.INVALID
        this.__permissionChangeListeners = new ListenerManager()
    }

    /**
     * Register for permission
     * @param {function} cb 
     * @returns {string|null} Key if successfull
     */
    registerForPermissionChangeCb(cb) {
        if (Utils.isNull(cb)) {
            return null
        }

        return this.__permissionChangeListeners.addListener(cb)
    }

    /**
     * Unregister a listener. 
     * @param {string} key 
     * @returns {boolean} True if removed successfully.
     */
    unregisterForKey(key) {
        if (Utils.isNull(key)) {
            return false
        }
        return this.__permissionChangeListeners.removeListener(key)
    }

    getPermissionStatus() {
        return this.__currentPermissionStatus
    }

    setPermissionStatus(newStatus) {
        if (Utils.isNull(newStatus)) {
            return false
        }

        // Verifying if the new status is within the constants range
        switch (newStatus) {
            case Constants.LOCATION_PERMISSION_STATUS.INVALID:
            case Constants.LOCATION_PERMISSION_STATUS.GRANTED:
            case Constants.LOCATION_PERMISSION_STATUS.DENIED:
                // Pass
                break
            default:
                return false
        }

        if (this.__currentPermissionStatus === newStatus) {
            // Skip calling the listeners if they values don't change
            return true
        }

        // Update the permission status
        this.__currentPermissionStatus = newStatus

        // Call cbs
        new Promise((resolve, reject) => {
            if (Utils.isNull(this.__permissionChangeListeners) || this.__permissionChangeListeners.length() <= 0) {
                resolve()
                return
            }

            this.__permissionChangeListeners.getAllListeners().forEach((cb) => {
                try {
                    cb()
                } catch (err) {
                    console.log("Error executing callback - ", err)
                }
            })
            resolve()
        })

        return true
    }
}

let instance = new LocationPermissionStore()
export default instance


// WEBPACK FOOTER //
// ./src/stores/locationPermissionStore.js